import Vue from 'vue';
import Router from './router';
import store from './store';
import VueSweetalert2 from 'vue-sweetalert2';

import $ from 'jquery';
import 'ion-rangeslider';

window.$ = window.jQuery = $; 

import App from './App'

Vue.use(VueSweetalert2);

new Vue({
  store,
  render: h => h(App),
  router: Router
}).$mount('#runway-app')



// WEBPACK FOOTER //
// ./src/main.js